export default __webpack_public_path__ + "media/big-goose-party2x.d52b258f.png";